import { useState, useEffect } from 'react';
import { useWindowSize } from 'usehooks-ts';

import { isServer } from '../../utils/env';

export default function useShowAd(size = 1024) {
  const [canDisplayAd, setCanDisplayAd] = useState(false);
  const { width } = useWindowSize();

  useEffect(() => {
    setCanDisplayAd(!isServer());
  }, []);

  return {
    showMobileAd: canDisplayAd && width < size,
    showDesktopAd: canDisplayAd && width >= size,
  };
}
